import { useCallback } from "react";
import {
  useTeamNotesQuery,
  useUpsertTeamNoteMutation,
} from "@/features/teams/graphql/generated";
import { useToast } from "@/shared/contexts/toast.context";

type UpsertTeamNoteInput = {
  note: string;
  type: string;
  personId?: number;
  id?: number;
};

export const useTeamNotes = (teamId: number, personId?: number) => {
  const { showToast } = useToast();
  const { data, loading, error } = useTeamNotesQuery({
    variables: {
      filter: {
        team_id: teamId,
        person_id: personId || null,
        type: "summary",
      },
    },
  });

  const notes = data?.teamNotes;

  const [upsertTeamNote] = useUpsertTeamNoteMutation();
  // const [deleteTeamNote,] = useDeleteTeamNoteMutation();

  const handleUpsertTeamNote = useCallback(
    (input: UpsertTeamNoteInput) => {
      upsertTeamNote({
        variables: {
          teamId,
          ...input,
          personId: personId || null,
          note: input.note,
          type: input.type,
          id: input.id || null,
        },
      });
    },
    [teamId, personId]
  );

  const handleDeleteTeamNote = useCallback(
    (id: number, type: string) => {
      handleUpsertTeamNote({
        note: "",
        type,
        id,
      });
    },
    [handleUpsertTeamNote]
  );

  return {
    notes,
    loading,
    error,
    handleUpsertTeamNote,
    handleDeleteTeamNote,
  };
};
